<ion-header>
  <ion-toolbar class="no-box-shadow" mode="ios">
    <ion-buttons
      (click)="closeModal()"
      slot="start"
      style="cursor: pointer"
      padding
    >
      <ion-icon
        color="medium"
        slot="icon-only"
        style="width: 20px; margin-right: 3px"
        [icon]="'./assets/back-arrow.svg'"
      ></ion-icon>
      <span class="back-btn">Back</span>
    </ion-buttons>
    <ion-title modal-title>{{ title || "Add Quantity & Rate" }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content text-center>
  <img [src]="orderItem?.item.icon" width="56px" />
  <form (ngSubmit)="onSubmit()" #rateQuantityForm1="ngForm" id="form">
    <ion-grid>
      <ion-row text-center="" input-white="">
        <ion-col
          size="12"
          text-center=""
          no-padding-left=""
          no-padding-right=""
        >
          <ion-text
            [style.background]="orderItem?.item.colorCode"
            text-center
            font-medium=""
            color="medium"
            class="title-label"
            >{{ orderItem?.item.name }}</ion-text
          >
        </ion-col>

        <!--EDIT PRICE-->
        <ion-col
          size="12"
          class="enter-quantity-label"
          *ngIf="priceEdit || priceEdit === qtyEdit"
        >
          <ion-label margin-top="" text-center="" font-regular=""
            >ENTER PRICE</ion-label
          >
        </ion-col>
        <ion-col
          size="6"
          offset="3"
          text-center
          *ngIf="priceEdit || priceEdit === qtyEdit"
        >
          <ion-item class="edit-quantity-item" lines="none">
            <ion-button
              class="qty-btn minus-button"
              float-left=""
              [disabled]="price <= 0"
              (click)="price = price - 1; priceInput.setFocus()"
            >
              <ion-icon color="medium" padding-5="" name="remove"></ion-icon>
            </ion-button>
            <ion-input
              class="enter-quantity-input"
              tabindex="1"
              maxlength="10"
              [tabIndex]="1"
              #priceInput
              type="number"
              min="0"
              max="200"
              [(ngModel)]="price"
              placeholder="0.00"
              name="price"
              id="price"
            ></ion-input>
            <ion-button
              class="qty-btn plus-button"
              tabindex="500"
              float-right=""
              (click)="price = price + 1; priceInput.setFocus()"
            >
              <ion-icon color="medium" padding-5="" name="add"></ion-icon>
            </ion-button>
          </ion-item>
          <ion-label
            no-margin
            slot="end"
            class="item-quantity-label"
            color="medium"
            text-medium
            >{{ orderItem?.item?.unitType | titlecase }}</ion-label
          >
        </ion-col>

        <!--EDIT QUANTITY-->
        <ion-col
          size="12"
          class="enter-quantity-label"
          *ngIf="qtyEdit || priceEdit === qtyEdit"
        >
          <ion-label margin-top="" text-center="" font-regular=""
            >ENTER QUANTITY</ion-label
          >
        </ion-col>
        <ion-col
          size="6"
          offset="3"
          text-center
          *ngIf="qtyEdit || priceEdit === qtyEdit"
        >
          <ion-item border-radius-10="" class="edit-quantity-item" lines="none">
            <ion-button
              min="0"
              class="qty-btn minus-button"
              target="400"
              float-left=""
              [disabled]="quantity <= 0"
              (click)="quantity = quantity - 1; qtyInput.setFocus()"
            >
              <ion-icon
                color="medium"
                mode="ios"
                padding-5=""
                name="remove"
              ></ion-icon>
            </ion-button>
            <ion-input
              class="enter-quantity-input"
              tabindex="2"
              maxlength="10"
              #qtyInput
              [tabIndex]="2"
              type="number"
              min="0"
              max="200"
              [(ngModel)]="quantity"
              placeholder="0"
              name="qty"
              id="qty"
            ></ion-input>
            <ion-button
              max="200"
              class="qty-btn plus-button"
              float-right=""
              (click)="quantity = quantity + 1; qtyInput.setFocus()"
            >
              <ion-icon
                color="medium"
                mode="ios"
                padding-5=""
                name="add"
              ></ion-icon>
            </ion-button>
          </ion-item>
          <ion-label
            no-margin
            slot="end"
            class="item-quantity-label"
            color="medium"
            text-medium
            >{{ orderItem?.item?.unitType | titlecase }}</ion-label
          >
        </ion-col>
      </ion-row>
    </ion-grid>
    <button type="submit" tabindex="600" #submitBtn [hidden]="true">
      Submit
    </button>
  </form>
</ion-content>
<ion-footer no-box-shadow>
  <ion-col size="12">
    <ion-button
      centered
      type="submit"
      (click)="submitBtn.click()"
      class="ion-no-margin"
      recykal-button
      size="large"
      expand="block"
      color="primary"
    >
      Proceed
    </ion-button>
  </ion-col>
</ion-footer>
